import { ApiRole } from '@r/role';
import { getData } from '@r/index';

const portType = 'userCenter'

interface selfConfigData extends ApiRole {
    data?: {
        _times?: number,
        [propName: string]: any
    },
    header?:{
        [propName: string]: any
    }

}



// 获取用户信息
export const accountLogin = (option: selfConfigData = {}):any => {

    option.url = 'account/login'
    option.type = 'post'
    option.portType = portType
    option.isremoveToken = true
    return getData(option);
}

//获取科室列表
export const departmentQuery = (option: selfConfigData = {}):any => {
    option.url = 'department/pageQuery'
    option.type = 'get'
    option.portType = portType
    return getData(option);
}

//获取科室详情
export const getDepartmentDetails = (option: selfConfigData = {}):any => {
    option.url = 'department/getById'
    option.type = 'get'
    option.portType = portType
    return getData(option);
}

// 新增科室
export const addDepartment = (option: selfConfigData = {}):any => {
    option.url = 'department/add'
    option.type = 'post'
    option.portType = portType
    return getData(option);
}

//删除科室
export const deleteDepartment = (option: selfConfigData = {}):any => {
    option.url = 'department/delete'
    option.type = 'post'
    option.portType = portType
    return getData(option);
}

//通过token 获取用户信息
export const getLoginAccount = (option: selfConfigData = {}):any => {
    option.url = 'account/getLoginAccount'
    option.type = 'get'
    option.portType = portType
    return getData(option);
}



//修改科室
export const updateDepartment = (option: selfConfigData = {}):any => {
    option.url = 'department/update'
    option.type = 'post'
    option.portType = portType
    return getData(option);
}

//获取用户的菜单
export const getMenuByLoginAccount = (option: selfConfigData = {}):any => {
    option.url = 'account/getMenuByLoginAccount'
    option.type = 'get'
    option.portType = portType
    return getData(option);
}

//科室列表
export const getDepartment = (option: selfConfigData = {}):any => {
    option.url = 'department/query'
    option.type = 'get'
    option.portType = portType
    return getData(option);
}

//机构列表
export const getOrganization = (option: selfConfigData = {}):any => {
    option.url = 'organization/query'
    option.type = 'get'
    option.portType = portType
    return getData(option);
}



//机构管理列表
export const getOrganizationList = (option: selfConfigData = {}):any => {
    option.url = 'organization/pageQuery'
    option.type = 'get'
    option.portType = portType
    return getData(option);
}

//新增机构
export const addOrganization = (option: selfConfigData = {}):any => {
    option.url = 'organization/addOrg'
    option.type = 'post'
    option.portType = portType
    return getData(option);
}

//修改机构
export const updateOrganization = (option: selfConfigData = {}):any => {
    option.url = 'organization/updateOrg'
    option.type = 'post'
    option.portType = portType
    return getData(option);
}

//多条件查询
export const MultiQueries = (option: selfConfigData ={}):any => {
    // option.url = 'organization/multiQueries'
    // option.type = 'post'
    option.portType = portType
    return getData(option);
}

//获取机构性质 /api/organization/getOrgNature
export const getOrgNature = (option: selfConfigData ={}):any => {
    option.url = 'organization/getOrgNature'
    option.type = 'get'
    option.portType = portType
    return getData(option);
}